import { isSwedishVersion } from "./location";

let defaultLanguage = isSwedishVersion() ? "sv" : "fi";

export const retrieveLanguage = () => localStorage.getItem("language") || defaultLanguage;

export const storeLanguage = (la: string) => localStorage.setItem("language", la);
